/**
 * Entry point for the React app: sets up the root element and renders <App/>.
 * Referenced from `src/index.html`.
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Self-hosted variable fonts — imported here so Bun bundles the woff2 locally.
// No CDN / Google Fonts: the demo must run fully offline.
import '@fontsource-variable/fraunces'
import '@fontsource-variable/hanken-grotesk'
import '@fontsource-variable/jetbrains-mono'

import { App } from './App'

const elem = document.getElementById('root')!
const app = (
  <StrictMode>
    <App />
  </StrictMode>
)

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  import.meta.hot.data.root ??= createRoot(elem)
  const root = import.meta.hot.data.root
  root.render(app)
} else {
  createRoot(elem).render(app)
}
